var React = require('react');

function FilterDash (props) {
    return React.createElement("svg",props,React.createElement("line",{"x1":"15","transform":"translate(0.5 0.5)","fill":"none","stroke":"#00C6CC","strokeLinecap":"round","strokeWidth":"1"}));
}

FilterDash.defaultProps = {"width":"16","height":"1","viewBox":"0 0 16 1"};

module.exports = FilterDash;

FilterDash.default = FilterDash;
